import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { closeModal, minimizeModal } from './redux/GlobalModalActions'
import useDraggable from './../../hooks/useDraggable'
import './index.css'

const ModalTemplate = ({
  Component,
  title,
  closeModal,
  id,
  minimizeModal,
  size,
  isHidden,
  modalTop = 5,
  modalLeft = 15,
  overflowY,
  scrollbarWidth,
  minHeight,
  onCloseModalClick,
}) => {
  const modalRef = useRef(null)
  const draggingElementRef = useRef(null)

  const [mouseStyle, setMouseStyle] = useState({ cursor: 'grab' })

  useDraggable(modalRef, draggingElementRef)
  const close = () => {
    onCloseModalClick && onCloseModalClick()
    closeModal(id)
  }
  return (
    <>
      <div
        className='moveDiv'
        style={{
          top: `${modalTop}vh`,
          left: modalLeft === 'auto' ? 'auto' : `${modalLeft}vw`,
          width: size ? `${size}px` : '60vw',
          visibility: isHidden ? 'hidden' : 'visible',
          minHeight: minHeight ? minHeight : 'auto',
        }}
        ref={modalRef}
      >
        <div
          className='globalModalHeader'
          ref={draggingElementRef}
          onMouseDown={() => {
            setMouseStyle({ cursor: 'move' })
          }}
          onMouseUp={() => setMouseStyle({ cursor: 'grab' })}
          style={mouseStyle}
        >
          <div className='globalModalHeader_title'>{title}</div>
          <div className='globalModalButtons globalModalHeader_buttons' style={mouseStyle}>
            <div>
              <Button color='warning' size='sm' onClick={() => minimizeModal(id)}>
                <i className='fa fa-window-minimize	'></i>
              </Button>
              <Button color='danger' size='sm' onClick={close}>
                <i className='fa fa-window-close	'></i>
              </Button>
            </div>
          </div>
        </div>
        <div
          className='globalModalContent'
          style={{ overflowY: overflowY || 'none', scrollbarWidth: scrollbarWidth || 'auto' }}
        >
          {Component}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = () => {
  return {}
}

export default connect(mapStateToProps, { closeModal, minimizeModal })(ModalTemplate)
